'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIAbstractPageSection = require('../page/UIAbstractPageSection');

var _UIAbstractPageSection2 = _interopRequireDefault(_UIAbstractPageSection);

var _UIStickyFooter = require('./UIStickyFooter');

var _UIStickyFooter2 = _interopRequireDefault(_UIStickyFooter);

var _Styles = require('../utils/Styles');

var _theme = require('HubStyleTokens/theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var StickyFooter = (0, _styledComponents2.default)(_UIStickyFooter2.default).withConfig({
  displayName: 'UIFixedSaveBar__StickyFooter'
})(['&&{background-color:', ';border-top:1px solid ', ';box-shadow:none;padding-bottom:20px;padding-top:20px;}'], _theme.PANEL_FOOTER_BACKGROUND_COLOR, _theme.PANEL_FOOTER_BORDER_COLOR);

var PageSection = (0, _styledComponents2.default)(_UIAbstractPageSection2.default).withConfig({
  displayName: 'UIFixedSaveBar__PageSection'
})(['.space-sword--max-width &{', '}'], (0, _Styles.setTemplateMaxWidth)());

exports.default = _react2.default.createClass({
  displayName: 'UIFixedSaveBar',

  propTypes: _UIStickyFooter2.default.propTypes,

  getDefaultProps: function getDefaultProps() {
    return _UIStickyFooter2.default.defaultProps;
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        rest = _objectWithoutProperties(_props, ['children', 'className']);

    return _react2.default.createElement(
      StickyFooter,
      _extends({}, rest, { className: className }),
      _react2.default.createElement(
        PageSection,
        null,
        children
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/panel/UIFixedSaveBar.js
// module id = 570
// module chunks = 171